export default __webpack_public_path__ + "static/media/hardwoodFinishes.c867853a.jpg";